import { Trans } from 'react-i18next';
import { BASIC } from '@hotjar/webapp/domains/revenue/plan/feature-group';
import { FeatureList, DefaultFeaturesHeading } from './components';

interface BasicPlanDetailsProps {
  hasCC: boolean;
}

export function BasicPlanDetails({ hasCC }: BasicPlanDetailsProps): JSX.Element {
  return (
    <FeatureList heading={<DefaultFeaturesHeading plan={BASIC} />}>
      {hasCC ? (
        <Trans i18nKey="activation:dashboard.post-install-card.plan-features.continuous-heatmaps-recordings">
          <b>Continuously building insights.</b> Your user sessions automatically turned into
          Heatmaps & Recordings.
        </Trans>
      ) : (
        <Trans i18nKey="activation:dashboard.post-install-card.plan-features.up-to-3-heatmaps-and-300-recordings">
          <b>See what your users care about.</b> Create 3 Heatmaps & capture up to 300 Recordings.
        </Trans>
      )}
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.up-to-3-surveys-and-feedback">
        <b>Gather their feedback.</b> Create 3 Surveys & Feedback widgets.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.unlimited-team-size">
        <b>There’s room for everyone.</b> Unlimited seats for your team.
      </Trans>
    </FeatureList>
  );
}
